import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const FalconLightBoxGallery = ({ images, children }) => {
  const [imgIndex, setImgIndex] = useState(null);
  return (
    <div>
      {children(setImgIndex)}
      <Lightbox
        open={imgIndex !== null}
        close={() => setImgIndex(null)}
        slides={images.map(src => ({ src }))}
        index={imgIndex ?? 0}
        on={{ view: ({ index }) => setImgIndex(index) }}
        styles={{ root: { zIndex: 999999 } }}
      />
    </div>
  );
};

FalconLightBoxGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.func.isRequired
};

export default FalconLightBoxGallery;
